//
import PreviewImage from '../PreviewImage';
import { CustomFile } from '../../FormUploadFile.interfaces';

interface Props {
    file: CustomFile | string | null;
}

const AvatarPreview = (props: Props) => {
    const { file } = props;
    if (!file) {
        return null;
    }

    const imgUrl = typeof file === 'string' ? file : file.preview;

    return (
        <PreviewImage
            alt="avatar"
            src={imgUrl}
            sx={{
                zIndex: 8,
                overflow: 'hidden',
                borderRadius: '50%',
                position: 'absolute',
                width: `calc(100% - 16px)`,
                height: `calc(100% - 16px)`,
            }}
        />
    );
};

export default AvatarPreview;
